/* eslint-disable react/prop-types */
import React from "react";
import { AuthProvider } from "./auth";
import { StudentProvider } from "./student";
import { ProfilesProvider } from "./profile";
import { ModulosProvider } from "./module";
import { ClassProvider } from "./class";
import { SinalarioProvider } from "./sinalario";
import { ContentProvider } from "./content";

const AppProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ClassProvider>
    <ModulosProvider>
      <ProfilesProvider>
        <StudentProvider>
          <SinalarioProvider>
            <ContentProvider>
              <AuthProvider>{children}</AuthProvider>
            </ContentProvider>
          </SinalarioProvider>
        </StudentProvider>
      </ProfilesProvider>
    </ModulosProvider>
  </ClassProvider>
);

export default AppProvider;
